import type { JssStyle } from 'jss';

import { ESize } from '@common/enums';

import { ThemeFontTags } from '@sites/site-theme/src/enums/font-tags.enum';
import { ThemeFontProperties } from '@sites/site-theme/src/enums/font-properties.enum';
import { themeFontCss } from '@sites/site-theme/src/utils/variables';

// TODO: !!!!!!!!!!!!!!!!!!!!!

// TEXT STYLES
const textCommon: JssStyle = {
    padding: 0,
};

export const themeH1Styles: JssStyle = {
    ...textCommon,
    fontFamily: themeFontCss(ThemeFontTags.h1, ThemeFontProperties.fontFamily),
    fontSize: themeFontCss(ThemeFontTags.h1, ThemeFontProperties.fontSize),
    fontWeight: themeFontCss(ThemeFontTags.h1, ThemeFontProperties.fontWeight),
    fontStyle: themeFontCss(ThemeFontTags.h1, ThemeFontProperties.fontStyle),
    lineHeight: themeFontCss(ThemeFontTags.h1, ThemeFontProperties.lineHeight),
    textTransform: themeFontCss(ThemeFontTags.h1, ThemeFontProperties.textTransform),
};

export const themeH2Styles: JssStyle = {
    ...textCommon,
    fontFamily: themeFontCss(ThemeFontTags.h2, ThemeFontProperties.fontFamily),
    fontSize: themeFontCss(ThemeFontTags.h2, ThemeFontProperties.fontSize),
    fontWeight: themeFontCss(ThemeFontTags.h2, ThemeFontProperties.fontWeight),
    fontStyle: themeFontCss(ThemeFontTags.h2, ThemeFontProperties.fontStyle),
    lineHeight: themeFontCss(ThemeFontTags.h2, ThemeFontProperties.lineHeight),
    textTransform: themeFontCss(ThemeFontTags.h2, ThemeFontProperties.textTransform),
};

export const themeH3Styles: JssStyle = {
    ...textCommon,
    fontFamily: themeFontCss(ThemeFontTags.h3, ThemeFontProperties.fontFamily),
    fontSize: themeFontCss(ThemeFontTags.h3, ThemeFontProperties.fontSize),
    fontWeight: themeFontCss(ThemeFontTags.h3, ThemeFontProperties.fontWeight),
    fontStyle: themeFontCss(ThemeFontTags.h3, ThemeFontProperties.fontStyle),
    lineHeight: themeFontCss(ThemeFontTags.h3, ThemeFontProperties.lineHeight),
    textTransform: themeFontCss(ThemeFontTags.h3, ThemeFontProperties.textTransform),
};

export const themeH4Styles: JssStyle = {
    ...textCommon,
    fontFamily: themeFontCss(ThemeFontTags.h4, ThemeFontProperties.fontFamily),
    fontSize: themeFontCss(ThemeFontTags.h4, ThemeFontProperties.fontSize),
    fontWeight: themeFontCss(ThemeFontTags.h4, ThemeFontProperties.fontWeight),
    fontStyle: themeFontCss(ThemeFontTags.h4, ThemeFontProperties.fontStyle),
    lineHeight: themeFontCss(ThemeFontTags.h4, ThemeFontProperties.lineHeight),
    textTransform: themeFontCss(ThemeFontTags.h4, ThemeFontProperties.textTransform),
};

export const themePStyles: JssStyle = {
    ...textCommon,
    fontFamily: themeFontCss(ThemeFontTags.p, ThemeFontProperties.fontFamily),
    fontSize: themeFontCss(ThemeFontTags.p, ThemeFontProperties.fontSize),
    fontWeight: themeFontCss(ThemeFontTags.p, ThemeFontProperties.fontWeight),
    fontStyle: themeFontCss(ThemeFontTags.p, ThemeFontProperties.fontStyle),
    lineHeight: themeFontCss(ThemeFontTags.p, ThemeFontProperties.lineHeight),
    textTransform: themeFontCss(ThemeFontTags.p, ThemeFontProperties.textTransform),
};
// END TEXT STYLES

export const commonFontSizeCoefficient = {
    [ESize.S]: 0.8,
    [ESize.M]: 1,
    [ESize.L]: 1.2,
};
